import type { BiasTag, ErrorType, FacetKey, Kind, MetricKey, Relation } from './types';

export const KIND: Record<Kind, string> = {
  definition: '정의', principle: '원리', example: '사례', application: '활용',
  counterexample: '반례', link: '연결', custom: '직접 질문',
};

export const RELATION: Record<Relation, string> = {
  related: '관련', causes: '원인 → 결과', part_of: '부분 → 전체', opposite: '대조',
  similar: '유사', example_of: '사례 → 개념', prerequisite: '선행 지식',
};

export const ERROR: Record<ErrorType, string> = {
  forgot: '전혀 기억 안 남', partial: '일부만 기억', confused: '다른 개념과 혼동',
  misconception: '잘못 알고 있었음', cannot_apply: '알지만 적용 못 함',
};

export const BIAS: Record<BiasTag, string> = {
  overconfidence: '과신', underconfidence: '과소확신', base_rate_neglect: '기준율 무시',
  confirmation: '확증 편향', anchoring: '앵커링(처음 숫자에 끌림)', planning_fallacy: '계획 오류·낙관',
  recency: '최근 일 과대평가', wishful: '희망적 사고', info_gap: '정보 부족',
  luck: '운 (판단은 합리적)', none: '문제 없음',
};

export const RATING = [
  { v: 1, label: '다시', hint: '기억 못 함', tone: 'bad' },
  { v: 2, label: '어려움', hint: '겨우 떠올림', tone: 'warn' },
  { v: 3, label: '좋음', hint: '기억함', tone: 'good' },
  { v: 4, label: '쉬움', hint: '바로 떠올림', tone: 'accent' },
] as const;

export const UNDERSTANDING = ['', '용어만 들어 봄', '대략 설명 가능', '예를 들 수 있음', '새 상황에 적용 가능', '남에게 가르칠 수 있음'];

export const QUALITY = ['', '나쁨', '아쉬움', '보통', '좋음', '아주 좋음'];

export const FACET_FIELDS: { key: FacetKey; label: string; hint: string }[] = [
  { key: 'definition', label: '정의', hint: '한두 문장으로. 책 문장 그대로가 아니라 내 말로.' },
  { key: 'principle', label: '원리', hint: '왜, 어떻게 작동하나? 원인 → 결과의 사슬로.' },
  { key: 'examples', label: '실제 사례', hint: '직접 보거나 겪은 구체적인 예일수록 오래 갑니다.' },
  { key: 'applications', label: '활용 방법', hint: '내 일·사업·투자에서 어디에 써먹나?' },
  { key: 'counterexamples', label: '반례·한계', hint: '언제 성립하지 않나? 경계 조건.' },
];

export function cardState(c: { reps: number; state: number; suspended: number }): string {
  if (c.suspended) return '쉬는 중';
  if (c.reps === 0) return '새 카드';
  if (c.state === 2) return '복습';
  return c.state === 3 ? '재학습' : '학습 중';
}

export function formatMetric(key: MetricKey, v: number | null): string {
  if (v == null) return '데이터 부족';
  if (key === 'brier_90d') return v.toFixed(3);
  if (key === 'retention_30d') return `${v.toFixed(1)}%`;
  const unit = { items_total: '개', mature_cards: '장', predictions_resolved: '건', review_days_30d: '일' }[key];
  return `${Math.round(v)}${unit}`;
}
